import { call, put, takeEvery } from 'redux-saga/effects';
import API from 'library/constants/api';
import request from 'library/helpers/request';
import * as constants from './constants';
import * as actions from './actions';

function* getManufacturers(action) {
  try {
    const params = {
      query: {
        limit: 10000,
        name: action?.payload?.name ?? '',
      },
    };

    const { data } = yield call(request, API.BROWSE_MANUFACTURERS_BY_NAME, 'GET', params);
    yield put(actions.getManufacturersSuccess(data));
  } catch (e) {
    yield put(actions.getManufacturerssError(e));
  }
}

// eslint-disable-next-line import/prefer-default-export
export function* getManufacturersWatcher() {
  yield takeEvery(constants.GET_MANUFACTURERS, getManufacturers);
}
